module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Kidnapped By the Taliban: A Story of Terror, Hope, and Rescue By Seal Team Six")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "p0009-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('p', {
    staticClass: "cct11",
    attrs: {
      "id": "p0009-02-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('i')]), _c('i', [_c('a', {
    attrs: {
      "href": "#/chapter3#cap0",
      "id": "con0"
    }
  }, [_vm._v("Prologue: Kidnapped")])])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-03-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4#cap1",
      "id": "con1"
    }
  }, [_vm._v("1. Finding My Way")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#cap2",
      "id": "con2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Afghanistan")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#cap3",
      "id": "con3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Anguish and Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#cap4",
      "id": "con4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Taliban Hospitality")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#cap5",
      "id": "con5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Bad News")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#cap6",
      "id": "con6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. “We’re Going to Kill You”")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#cap7",
      "id": "con7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Whatever This Is")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#cap8",
      "id": "con8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Demands")])]), _vm._v(" "), _c('p', {
    staticClass: "cctt",
    attrs: {
      "id": "p0009-P-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#cap9",
      "id": "con9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Conversation")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#cap10",
      "id": "con10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Connections")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#cap11",
      "id": "con11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. A Precarious Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#cap12",
      "id": "con12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Shifting Demands")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#cap13",
      "id": "con13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. “Papa’s in Trouble”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-P-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#cap14",
      "id": "con14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. On the Run")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }), _c('span', {
    attrs: {
      "href": "#/chapter18#cap15",
      "id": "con15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Taliban Dry My Tears")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#cap16",
      "id": "con16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Last Night")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#cap17",
      "id": "con17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Rescue")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#cap18",
      "id": "con18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Reborn")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0010-P-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#cap19",
      "id": "con19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Home")])]), _vm._v(" "), _c('p', {
    staticClass: "cct12",
    attrs: {
      "id": "p0010-02-2"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/chapter23#cap20",
      "id": "con20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Heartache and Joy")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0010-P-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#cap21",
      "id": "con21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0010-P-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#cap22",
      "id": "con22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0010-P-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#cap23",
      "id": "con23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0010-P-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#cap24",
      "id": "con24",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Recommended Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0010-P-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#cap25",
      "id": "con25",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1"
  }, [_c('span', {
    attrs: {
      "href": "#/forward3#cap26",
      "id": "con26",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Photos")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0